---
title: AGB
updated: 2026-10-02
---

## 1. Annahme der Bedingungen

Durch die Erstellung eines Kontos oder die Nutzung von Draughts Game („der Dienst") stimmst du diesen Nutzungsbedingungen zu. Wenn du nicht einverstanden bist, nutze den Dienst bitte nicht.

## 2. Beschreibung des Dienstes

Draughts Game ist eine Online-Plattform zum Damespielen in mehreren Varianten. Der Dienst umfasst Matchmaking gegen andere Spieler oder den Computer, Turniere, Spieler-Ratings, Taktikaufgaben und Funktionen zur Partieanalyse.

## 3. Kontoregistrierung

Um auf bestimmte Funktionen zuzugreifen, musst du ein Konto mit Benutzernamen, E-Mail-Adresse und Passwort erstellen. Du musst deine E-Mail-Adresse bestätigen, bevor du dich anmelden kannst. Du bist für die Vertraulichkeit deiner Zugangsdaten verantwortlich. Du kannst auch ohne Registrierung als Gast spielen, mit eingeschränktem Funktionsumfang.

- Du musst mindestens 16 Jahre alt sein, um ein Konto zu erstellen.
- Pro Person darf nur ein Konto erstellt werden.
- Du bist für alle Aktivitäten verantwortlich, die über dein Konto erfolgen.

## 4. Verhalten der Nutzer

Bei der Nutzung des Dienstes verpflichtest du dich, Folgendes zu unterlassen:

- Externe Hilfe (Engines, Löser) während gewerteter Partien zu verwenden.
- Partien absichtlich zu verlieren, um Ratings zu manipulieren (Sandbagging).
- Dich bei Turnieren mit anderen Spielern abzusprechen.
- Andere Nutzer zu belästigen, zu bedrohen oder zu beleidigen.
- Mehrere Konten zu erstellen, um Sperren zu umgehen oder Ranglisten zu manipulieren.
- Zu versuchen, Bugs oder Schwachstellen der Plattform auszunutzen.
- Automatisierte Tools (Bots) ohne Genehmigung zum Spielen zu verwenden.

## 5. Fairplay

Wir behalten uns das Recht vor, automatisierte Systeme zur Erkennung von Betrug und unfairem Spiel einzusetzen. Verstöße können nach unserem Ermessen zu Verwarnungen, vorübergehenden Sperren, Rating-Anpassungen oder dauerhaften Ausschlüssen führen.

## 6. Geistiges Eigentum

Der Dienst, einschließlich Design, Originalcode, Grafiken und Inhalten, ist Eigentum von Draughts Game. Partieaufzeichnungen (Züge, Ergebnisse) sind öffentliche Daten und dürfen frei geteilt werden. Nutzergenerierte Inhalte (Benutzernamen, Chatnachrichten) bleiben Eigentum ihrer jeweiligen Urheber.

## 7. Verfügbarkeit und Änderungen

Wir bemühen uns, den Dienst jederzeit verfügbar zu halten, garantieren jedoch keinen ununterbrochenen Zugang. Wir behalten uns das Recht vor, Teile des Dienstes jederzeit zu ändern, auszusetzen oder einzustellen. Wir können diese Bedingungen von Zeit zu Zeit aktualisieren. Die weitere Nutzung des Dienstes nach Änderungen gilt als Zustimmung.

## 8. Haftungsbeschränkung

Der Dienst wird „wie besehen" ohne jegliche ausdrückliche oder stillschweigende Gewährleistung bereitgestellt. Wir haften nicht für indirekte, zufällige oder Folgeschäden, die aus deiner Nutzung des Dienstes entstehen. Unsere Gesamthaftung übersteigt nicht den Betrag, den du uns in den 12 Monaten vor dem Anspruch gezahlt hast (falls zutreffend).

## 9. Kündigung

Du kannst dein Konto jederzeit in deinen Profileinstellungen („Konto löschen") oder durch Kontaktaufnahme mit uns löschen. Wir können dein Konto kündigen oder sperren, wenn du gegen diese Bedingungen verstößt oder dich in einer Weise verhältst, die dem Dienst oder anderen Nutzern schadet.

## 10. Kontakt

Bei Fragen zu diesen Bedingungen kontaktiere uns unter: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
